import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useFormik } from "formik";
import * as Yup from "yup";
import "./../../assets/css/Invite.scss";
import { Dropdown } from "primereact/dropdown";
import setinviteTeam from "../../Model/Inviteteam/setinviteTeam";
import { showError } from "../../components/ToastedMessage/ToastedMessage";
import useTitanApp from "../../hooks/useTitanApp";
import {
  changeMemberRole,
  getRoles,
  getTeams,
  inviteTeamMember,
  removeTeamMember,
} from "../../dispatchers/teamDispatchers";
import useTitanTeam from "../../hooks/useTitanTeam";
import { useRevalidator, useNavigate } from "react-router-dom";
import CustomLoader from "../controls/CustomLoader";
import {
  getApplicationData,
  setShowInviteTeamSideModal,
} from "../../dispatchers/appDispatchers";
import { TiUserAdd } from "react-icons/ti";
import { BsFillSendFill, BsFillTrash3Fill } from "react-icons/bs";
import { Tooltip } from "@mui/material";
import { IoClose } from "react-icons/io5";
import { Oval } from "react-loader-spinner";
import LottieLoader from "../controls/LottieLoader";

export default function InviteTeamSide({ clickedTeam }) {
  const [selectedOption, setSelectedOption] = useState(null);
  const [emailError, setEmailError] = useState("");
  const { appState, onboardingVerificationState } = useTitanApp();
  const { teamState } = useTitanTeam();
  const [isLoading, setIsLoading] = useState(false);
  const { roles, isRolesLoading, isTeamLoading } = teamState;
  const { darkMode, showInviteTeamSideModal } = appState || {};
  const { teamMembers } = clickedTeam || {};
  const { userData } = onboardingVerificationState || {};
  const { companyID } = userData || "";

  useEffect(() => {
    if (showInviteTeamSideModal) {
      getRoles(userData?.accountType === 2 ? 2 : 1).then((data) => {});
    }
  }, [showInviteTeamSideModal]);
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .test("emails", "Please enter valid email address", (value) => {
        if (!value) return true;
        const emails = value?.split(",");
        const regex =
          /^\s*([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\s*,\s*)*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\s*$/i; // email validation regex
        return emails.every((email) => regex.test(email.trim()));
      })
      .required("Role is required"),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema,
    onSubmit: (values, { resetForm }) => {},
  });

  const sendInvite = () => {
    if (!formik.values.email) {
      setEmailError("Email fields is required!");
    } else if (formik.touched.email && formik.errors.email) {
      setEmailError("Please type a valid email address!");
    } else if (selectedOption === null) {
      setEmailError("Role is required");
    } else {
      const myArray = formik.values.email.split(",");
      const EmailArray = new setinviteTeam(
        myArray,
        clickedTeam?.teamID,
        clickedTeam?.companyID || companyID,
        selectedOption
      ).obj;
      inviteTeamMember(EmailArray, clickedTeam?.teamID)
        .then((data) => {
          if (data === null) {
            showError("Email address already exists!");
          }
          getTeams();
          closeModal();
        })
        .catch((data) => {
          showError(data);
        });
    }
  };
  const closeModal = () => {
    setShowInviteTeamSideModal(false);
  };
  async function handleRoleChange(event, member) {
    setIsLoading(true);
    const roleModel = {
      userEmail: member?.email,
      companyID: member?.companyID,
      roleID: event?._id,
    };
    try {
      await changeMemberRole(roleModel);
      await getApplicationData(0);
    } catch (error) {
      console.error("Role update failed:", error);
    } finally {
      setIsLoading(false);
    }
  }
  function removeTeamMemberFromTeam(event, member) {
    setIsLoading(true);
    const { teamID } = clickedTeam;
    const { teamMemberID } = member;
    removeTeamMember({ teamID, teamMemberID }).then((data) => {
      setIsLoading(false);
      getTeams();
      closeModal();
      getApplicationData(0);
    });
  }
  return (
    <>
      <Modal
        show={showInviteTeamSideModal}
        onHide={() => setShowInviteTeamSideModal(false)}
        backdrop="static"
        centered
        dialogClassName="inviteModal"
      >
        <Modal.Header>
          <div className="cus-modal-header">
            <TiUserAdd size={20} color={darkMode ? "#bdbdbd" : "#0a0a0a"} />
            <h5>Invite to {clickedTeam?.teamName}</h5>
          </div>
          <IoClose
            color={darkMode ? "#bdbdbd" : "#0a0a0a"}
            onClick={closeModal}
            className="close-icon"
          />
        </Modal.Header>
        {isRolesLoading ? (
          <></>
        ) : (
          <>
            {isLoading ? (
              <div className="pharmacy-loader">
                <LottieLoader />
              </div>
            ) : (
              <>
                <form onSubmit={formik.handleSubmit}>
                  <div className="invite_form">
                    <div className="invite_email_div">
                      <div className="inviteList-email">
                        <input
                          id="email"
                          name="email"
                          type="text"
                          className="custom-input"
                          placeholder="Email"
                          value={formik.values.email}
                          onChange={formik.handleChange}
                        />

                        <Dropdown
                          value={selectedOption}
                          onChange={(e) => setSelectedOption(e.value)}
                          options={roles}
                          optionLabel="roleName"
                          placeholder="Select role"
                          className="invite-dropdown"
                          panelClassName="invite-dropdown-panel"
                        />
                      </div>
                      <div className="error-message">{emailError}</div>
                    </div>
                    <Tooltip title="Send Invite" arrow>
                      <div className="invite-arrow" onClick={sendInvite}>
                        <BsFillSendFill color="#333" />
                      </div>
                    </Tooltip>
                  </div>
                </form>
                <div className="team_members_list">
                  {clickedTeam?.teamMembers?.map((member, index) => {
                    const defaultSelectedRole = roles.find(
                      (role) => role?._id === member?.roleId
                    );
                    return isTeamLoading ? (
                      <div className="invite-loader">
                        <Oval
                          height={130}
                          width={130}
                          color={`${darkMode ? "#fff" : "#333"}`}
                          wrapperStyle={{}}
                          wrapperClass=""
                          visible={true}
                          ariaLabel="oval-loading"
                          secondaryColor={`${darkMode ? "#fff" : "#333"}`}
                          strokeWidth={2}
                          strokeWidthSecondary={2}
                        />
                      </div>
                    ) : (
                      <div className="team_members" key={index}>
                        <div className="team_member_name">
                          <p>{member?.userFullName}</p>
                        </div>
                        <div className="team_member_role">
                          <Dropdown
                            onChange={(e) => {
                              handleRoleChange(e?.value, member);
                            }}
                            value={defaultSelectedRole}
                            options={roles}
                            dialogClassName="invite-team-dialog"
                            optionLabel="roleName"
                            placeholder="Select role"
                            className="invite-team-list"
                            panelClassName="invite-dropdown-panel"
                          />
                          {teamMembers?.length > 1 ? (
                            <button
                              onClick={(e) =>
                                removeTeamMemberFromTeam(e?.value, member)
                              }
                            >
                              <BsFillTrash3Fill
                                size={14}
                                color={darkMode ? "#bdbdbd" : "#333"}
                              />
                            </button>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </>
            )}
          </>
        )}
      </Modal>
    </>
  );
}
